export default "__VITE_ASSET__BIblF8B0__"